import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { useLayout } from '../Layout/Layout';
import { LAYOUT_CONFIG } from '../../constants/layout';

interface PageContainerProps extends Omit<BoxProps, 'sx'> {
    children: React.ReactNode;
    isDatavizPage?: boolean;
    sx?: BoxProps['sx'];
}

const PageContainer: React.FC<PageContainerProps> = ({ 
    children,
    isDatavizPage = false,
    sx = {},
    ...props
}) => {
    const { layoutMode } = useLayout();
    
    const isHorizontal = layoutMode === 'horizontal';
    const topMargin = isHorizontal 
        ? LAYOUT_CONFIG.headerHeight + LAYOUT_CONFIG.horizontalMenuHeight 
        : LAYOUT_CONFIG.headerHeight;
    const containerHeight = `calc(100vh - ${topMargin}px)`;

    return (
        <Box
            sx={{
                ...(!isDatavizPage && {
                    m: 1
                }),
                ...(isDatavizPage && {
                    overflowY: 'hidden',
                    p: 0,
                    padding: 0,
                    height: containerHeight,
                    maxHeight: containerHeight,
                }),
                p: 1,
                fontFamily: 'Poppins, Arial, sans-serif',
                '& *': { fontFamily: 'inherit' },
                ...sx,
            }}
            {...props}
        >
            {children}
        </Box>
    );
};

export default PageContainer;
